'use strict';

angular.module('shiftTraderApp')
  .factory('UserPermissions', function (ServerUrls, $http, $q) {
    var UserPermissions = {};

    UserPermissions.getByUserId = function(userId) {
      var url = ServerUrls.current.railsApi + 'users/' + userId + '/permissions';

      return $http.get(url)
        .then(function(response) {
          return response.data;
        }, function(response) {
          return $q.reject(response);
        });
    };

    return UserPermissions;
  });

